import React, { useState, useEffect } from "react";
import "./HowItWorks.css"
import About from "../shared/About";

const HowItWorks = () => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <button id="openModalBtn" className="how-it-works-btn" onClick={() => setShowModal(true)}>? How it works</button>
            {showModal && (
                <div id="modalOverlay" className="modal-overlay">
                <div className="modal">
                  <div className="modal-header">
                    <h2>How it works</h2>
                    <button id="closeModalBtn" className="close-btn" onClick={() => setShowModal(false)}>&times;</button>
                  </div>
                  <About />
                </div>
              </div>
            )}
        </>        
    );
}

export default HowItWorks;